import React, { useEffect } from "react";
import { useState, useMemo } from "react";
import { getColorThemeEvalNat } from "../../../utils/evalnatfunction";
import { niveauDe } from "../../../utils/campagneEvalNat";
import { getChartData, getThemeProgressDataFromEvalNat } from "../../../utils/ClasseResultat";
import ThemeClassePieChart, { getThemeIcon } from "../../chart/ThemeClassePieChart";
import TestSpecifique from "./TestSpecifique";
import ResultatParItem from "./ResultatParItem";
import { useParams } from "react-router-dom";
import { useClasseContext } from "../../../context/ClasseContext";
import ExportEvalNatGroupe from "../ExportEvalNatGroupe";
import DataLoader from "../../../pages/DataLoader";
import { useUser } from "../../../context/UserContext";
import { BarChart3, Layers, ChevronDown } from "lucide-react";

function ResultatEvalNat({EvalsNat, classe, selectedMatiere}) {
    const {idclasse} = useParams();
    const {classeNom} = useClasseContext();
    const {user} = useUser();

    const EvalNat = EvalsNat.find(e =>
      e.titre === "Evaluation Nationale" &&
      (classe ? true : e.classe === parseInt(idclasse, 10)) &&
      e.eleves_reponses?.length > 0
  );

   const colorThemeData = getColorThemeEvalNat(EvalNat);
   const chartsData = getChartData(colorThemeData);
   const progressData = getThemeProgressDataFromEvalNat(colorThemeData);



   const [testSpecifique, setTestSpecifique] = useState('Automatismes')
   const [selectedThemeNat, setSelectedThemeNat] = useState(null);
   const [themesExpanded, setThemesExpanded] = useState(true);

   const [itemDetail, setItemDetail] = useState({});

const themes = [];
const matiere = selectedMatiere || (user.matiere && user.matiere)

// Calculer le testSpecifique correct AVANT le render pour éviter race condition
// Le niveau : celui de la classe ouverte, sinon celui de l'évaluation (une campagne le porte, D9).
const niveauEvaluation = niveauDe(EvalNat);
const niveau = classeNom[0]?.[0] || niveauEvaluation;
const correctTestSpecifique = (() => {
  if (matiere === 'maths') {
    return 'Automatismes';
  } else if (matiere === 'français' || matiere === 'Français') {
    if (niveau === '5') {
      return 'CompetencesLangagieres';
    } else {
      return 'Lexique';
    }
  }
  return 'Automatismes';
})();
// Utiliser le testSpecifique correct (state s'il est valide, sinon le calculé)
const currentTestSpecifique = testSpecifique === 'Problèmes' && (matiere === 'français' || matiere === 'Français')
  ? correctTestSpecifique
  : testSpecifique;


if (matiere === 'maths') {
   switch(niveau) {
    case '6':
      themes.push(
         { id: 'espace_et_geometrie', nom: 'Espace et Géométrie' },
          { id: 'nombre_de_calculs', nom: 'Nombre et Calculs' },
          { id: 'grandeurs_et_mesures', nom: 'Grandeurs et mesures' }
      );
      break;

    case '5':
      break;

    case '4':
      themes.push(
        { id: 'espace_et_geometrie', nom: 'Espace et Géométrie' },
        { id: 'nombre_de_calculs', nom: 'Nombre et Calculs' },
        { id: 'grandeurs_et_mesures', nom: 'Grandeurs et mesures' },
        { id: 'organisation_et_gestion_de_données', nom: "Organisation et Gestion de données" }
      );
      break;
      default:
      // Cas par défaut si le niveau n'est pas reconnu
      break;
  }
} else if (matiere === 'français' || matiere === 'Français') {
  // Utiliser la variable 'niveau' déjà définie plus haut
  switch(niveau) {
    case '6':
      themes.push(
        { id: 'comprehension_orale', nom: "Compréhension Orale" },
        { id: 'etude_langue_composition', nom: 'Étude de la Langue - Composition' },
        { id: 'orthographe', nom: 'Orthographe' },
        { id: 'fluence', nom: 'Fluence' },
        { id: 'lexique', nom: 'Lexique' },
        { id: 'comprehension_ecrite', nom: "Compréhension Écrite" },
      );
      break;

    case '5':
      themes.push(
        { id: 'competences_langagieres', nom: 'Compétences langagières et linguistiques' },
        { id: 'fluence', nom: 'Fluence' }
      );
      break;

    case '4':
      themes.push(
        { id: 'comprehension_orale', nom: "Compréhension Orale" },
        { id: 'comprehension_ecrite', nom: "Compréhension Écrite" },
        { id: 'etude_langue_composition', nom: 'Étude de la Langue - Composition' },
        { id: 'orthographe', nom: 'Orthographe' },
        { id: 'lexique', nom: 'Lexique' },
        { id: 'fluence', nom: 'Fluence' }
      );
      break;

    default:
      // Cas par défaut si le niveau n'est pas reconnu
      break;
  }
}



useEffect( ()=>{
  setItemDetail({})
  if (themes.length > 0) {
    setSelectedThemeNat(themes[0]);
  }
},[EvalNat, themes.length])

// Réinitialiser testSpecifique quand la matière change
useEffect(() => {
  const matiere = selectedMatiere || (user.matiere && user.matiere);

  if (matiere === 'maths') {
    setTestSpecifique('Automatismes');
  } else if (matiere === 'français' || matiere === 'Français') {
    // Déterminer le premier test selon le niveau
    const niveau = classeNom[0]?.[0] || niveauEvaluation;

    if (niveau === '5') {
      setTestSpecifique('CompetencesLangagieres');
    } else {
      setTestSpecifique('Lexique');
    }
  }
  setItemDetail({});
}, [selectedMatiere, user.matiere, classeNom, EvalNat?.classe, niveauEvaluation])

   const handleItemClick = (item) => {

        setItemDetail(item);
   }

   const handleTestSpecifiqueClick = (item) => {
        setTestSpecifique(item)
        setItemDetail({})
   }
   const AutomatismeQuestions = useMemo(() => {
    if(EvalNat)
        {return EvalNat.questions
      .filter(question => question.type_label === "Automatisme")
      .reduce((acc, question) => {
        const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => {
            return { ...rep };
          })
        : []; // Fallback sur un tableau vide si ce n'est pas un tableau

        acc[question.question_num] = {
          "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
          "reponses": reponses,
          "image": question.image,
          "bonne_reponse": question.bonne_reponse,
          "bonne_reponse_image": question.bonne_reponse_image,
          "elements_additionnels": question.elements_additionnels,
          "type_question": question.type_question || 'qcm'
        };

        return acc;
      }
     , {});
    } else{
      return {};
    }
  }, [EvalNat]);

  const ProblèmesQuestions = useMemo(() => {
    if(EvalNat){
    return EvalNat.questions
      .filter(question => question.type_label === "Résolution de problèmes")
      .reduce((acc, question) => {
        const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => {
            return { ...rep };
          })
        : []; // Fallback sur un tableau vide si ce n'est pas un tableau

        acc[question.question_num] = {
          "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
          "reponses": reponses,
          "image": question.image,
          "bonne_reponse": question.bonne_reponse,
          "bonne_reponse_image": question.bonne_reponse_image,
          "elements_additionnels": question.elements_additionnels,
          "type_question": question.type_question || 'qcm'
        };

        return acc;
      }, {});
    }
    else{
      return {}
    }
  }, [EvalNat]);

const LexiqueQuestion = useMemo(()=> {
   if(EvalNat){
    return EvalNat.questions
      .filter(question => question.type_label === "Lexique")
      .reduce((acc, question) => {
        const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => {
            return { ...rep };
          })
        : []; // Fallback sur un tableau vide si ce n'est pas un tableau

        acc[question.question_num] = {
          "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
          "reponses": reponses,
          "image": question.image,
          "bonne_reponse": question.bonne_reponse,
          "bonne_reponse_image": question.bonne_reponse_image,
          "elements_additionnels": question.elements_additionnels,
          "type_question": question.type_question || 'qcm'
        };

        return acc;
      }, {});
    }
    else{
      return {}
    }
},[EvalNat])

const ComprehensionEcritQuestion = useMemo(() => {
  if(EvalNat) {
    return EvalNat.questions
      .filter(question => question.type_label.startsWith("Compréhension de l'écrit"))
      .reduce((acc, question) => {
        const reponses = Array.isArray(question.reponses)
          ? question.reponses.map(rep => {
              const responseObj = { contenu: rep.contenu };
              if (rep.type) responseObj.type = rep.type;
              if (rep.image) responseObj.image = rep.image;
              return responseObj;
            })
          : [];

        // Extraire le nom du texte depuis type_label
        // "Compréhension de l'écrit Arachné" -> "Arachné"
        // "Compréhension de l'écrit Document Sommeil" -> "Sommeil"
        let texteName = question.type_label.replace("Compréhension de l'écrit ", "");

        // Si c'est "Document Sommeil", on garde juste "Sommeil"
        if (texteName.startsWith("Document ")) {
          texteName = texteName.replace("Document ", "");
        }

        // Créer la clé composite "Arachné Q1" ou "Sommeil Q1"
        const cleComposite = `${texteName} ${question.question_num}`;

        acc[cleComposite] = {
          "question": question.texte,
          "reponses": reponses,
          "image": question.image,
          "bonne_reponse": question.bonne_reponse,
          "bonne_reponse_image": question.bonne_reponse_image,
          "question_num": question.question_num,
          "elements_additionnels": question.elements_additionnels,
          "type_question": question.type_question || 'qcm'
        };

        return acc;
      }, {});
  } else {
    return {}
  }
}, [EvalNat])

const CompetencesLangagieresQuestion = useMemo(()=> {
   if(EvalNat){
    return EvalNat.questions
      .filter(question => question.type_label === 'Compétences langagières et linguistiques')
      .reduce((acc, question) => {
        const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => {
            return { ...rep };
          })
        : []; // Fallback sur un tableau vide si ce n'est pas un tableau

        acc[question.question_num] = {
          "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
          "reponses": reponses,
          "image": question.image,
          "bonne_reponse": question.bonne_reponse,
          "bonne_reponse_image": question.bonne_reponse_image,
          "elements_additionnels": question.elements_additionnels,
          "type_question": question.type_question || 'qcm'
        };

        return acc;
      }, {});
    }
    else{
      return {}
    }
},[EvalNat])

// Définir les boutons selon matière et niveau
const getTestButtons = (matiere, niveau) => {
  const buttons = [];

  if (matiere === 'maths') {
    // Automatismes pour tous
    buttons.push({ key: 'Automatismes', label: '📊 Automatismes' });
    // Problèmes seulement pour 6ème et 4ème
    if (niveau === '6' || niveau === '4') {
      buttons.push({ key: 'Problèmes', label: '📋 Résolutions de problèmes' });
    }
  } else if (matiere === 'français' || matiere === 'Français') {
    switch(niveau) {
      case '6':
        buttons.push({ key: 'Lexique', label: '📚 Lexique' });
        buttons.push({ key: 'ComprehensionEcrite', label: '📖 Compréhension écrite' });
        break;
      case '5':
        buttons.push({ key: 'CompetencesLangagieres', label: '💬 Compétences langagières' });
        break;
      case '4':
        buttons.push({ key: 'Lexique', label: '📚 Lexique' });
        buttons.push({ key: 'ComprehensionEcrite', label: '📖 Compréhension écrite' });
        break;
      default:
        buttons.push({ key: 'Lexique', label: '📚 Lexique' });
        buttons.push({ key: 'ComprehensionEcrite', label: '📖 Compréhension écrite' });
        break;
    }
  }

  return buttons;
}




// Utiliser la variable 'niveau' déjà définie plus haut (ligne 35)
const buttons = getTestButtons(matiere, niveau);

  if(!EvalNat){
    return(
      <div className="flex flex-col items-center justify-center p-12 xl:p-8 2xl:p-10 3xl:p-12 bg-white rounded-2xl shadow-lg mx-4 xl:mx-3 2xl:mx-3.5 3xl:mx-4 my-8 xl:my-5 2xl:my-6 3xl:my-8">
        <div className="relative mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6">
          <div className="w-24 h-24 xl:w-18 xl:h-18 2xl:w-20 2xl:h-20 3xl:w-24 3xl:h-24 bg-gradient-to-br from-sky-100 to-sky-200 rounded-full flex items-center justify-center">
            <svg className="w-12 h-12 xl:w-9 xl:h-9 2xl:w-10 2xl:h-10 3xl:w-12 3xl:h-12 text-sky-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div className="absolute -bottom-1 -right-1 w-8 h-8 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8 bg-orange-100 rounded-full flex items-center justify-center">
            <svg className="w-4 h-4 xl:w-3.5 xl:h-3.5 2xl:w-3.5 2xl:h-3.5 3xl:w-4 3xl:h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
        </div>
        <h3 className="text-xl xl:text-base 2xl:text-lg 3xl:text-xl font-bold text-gray-800 mb-2 xl:mb-1.5 2xl:mb-1.5 3xl:mb-2">Aucune évaluation nationale trouvée</h3>
        <p className="text-gray-500 text-center max-w-md mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6 xl:text-sm 2xl:text-sm 3xl:text-base">
          Les résultats de l'évaluation nationale ne sont pas encore disponibles pour cette sélection.
        </p>
        <div className="flex items-center gap-2 xl:gap-1.5 2xl:gap-1.5 3xl:gap-2 px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-2 xl:py-1.5 2xl:py-1.5 3xl:py-2 bg-sky-50 text-sky-700 rounded-lg text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">
          <svg className="w-4 h-4 xl:w-3.5 xl:h-3.5 2xl:w-3.5 2xl:h-3.5 3xl:w-4 3xl:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>Vérifiez que les données ont bien été importées</span>
        </div>
      </div>
    )
  }
    return(
        <div className="px-4 xl:px-3 2xl:px-3.5 3xl:px-4 h-full">
          <DataLoader typeComponent={"nationale"} elevesnat={EvalNat} />

          {/* Thèmes avec tabs */}
          {themes.length > 0 && (
            <div className="relative rounded-3xl border border-white/60 shadow-2xl shadow-blue-500/10 mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6 overflow-visible">
              {/* Fond dégradé immersif */}
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-slate-50 via-blue-50/80 to-cyan-50/60" />
              <div className="absolute -top-16 -right-16 w-48 h-48 bg-gradient-to-br from-blue-400/15 to-cyan-400/15 rounded-full blur-3xl pointer-events-none" />
              <div className="absolute -bottom-12 -left-12 w-40 h-40 bg-gradient-to-br from-teal-400/15 to-emerald-400/15 rounded-full blur-3xl pointer-events-none" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-32 bg-gradient-to-r from-blue-300/10 via-cyan-300/10 to-teal-300/10 rounded-full blur-2xl pointer-events-none" />

              {/* Header */}
              <div
                onClick={() => setThemesExpanded(!themesExpanded)}
                className="relative flex items-center justify-between px-5 xl:px-3 2xl:px-5 py-4 xl:py-2.5 2xl:py-4 border-b border-slate-100 rounded-t-3xl bg-gradient-to-r from-blue-50 via-sky-100 to-indigo-50/50 cursor-pointer hover:from-blue-100 hover:via-sky-150 hover:to-indigo-100/50 transition-all duration-200"
              >
                <div className="flex items-center gap-2.5">
                  <Layers className="w-5 h-5 xl:w-4 xl:h-4 text-indigo-600" />
                  <div>
                    <h3 className="text-slate-700 text-base xl:text-sm 2xl:text-base font-bold">Thèmes</h3>
                    <p className="text-xs xl:text-[11px] text-slate-400 font-medium hidden sm:block">Résultats par thème de l'évaluation</p>
                  </div>
                </div>
                <ChevronDown className={`w-5 h-5 text-indigo-600 transition-transform duration-300 ${themesExpanded ? 'rotate-180' : ''}`} />
              </div>

              {/* Contenu collapsible */}
              <div className={`overflow-hidden transition-all duration-300 ease-out ${themesExpanded ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}`}>
                {/* Tabs thèmes */}
                <div className="relative flex items-center gap-1.5 p-3 border-b border-blue-100/40 overflow-x-auto scrollbar-hide">
                  {themes.map(theme => {
                    const Icon = getThemeIcon(theme.nom);
                    const isSelected = selectedThemeNat?.id === theme.id;
                    const hasData = progressData?.[theme.nom]?.hasData;

                    return (
                      <button
                        key={theme.id}
                        onClick={() => setSelectedThemeNat(theme)}
                        className={`
                          flex items-center gap-1.5 px-4 py-2 rounded-xl whitespace-nowrap
                          transition-all duration-300 text-xs font-bold
                          ${isSelected
                            ? 'bg-gradient-to-r from-blue-600 via-cyan-500 to-teal-500 text-white shadow-lg shadow-blue-500/30 scale-105'
                            : 'text-slate-500 hover:text-blue-600 hover:bg-white/80 hover:shadow-md'
                          }
                          ${!hasData && !isSelected ? 'opacity-40' : ''}
                        `}
                      >
                        <Icon className="w-4 h-4" />
                        <span>{theme.nom}</span>
                      </button>
                    );
                  })}
                </div>

                {/* Contenu du thème sélectionné */}
                <div className="relative p-4">
                  {selectedThemeNat && (
                    <ThemeClassePieChart
                      chartsData={chartsData}
                      progressData={progressData}
                      theme={selectedThemeNat}
                      nature={"evalnat"}
                    />
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Main card with header + buttons + content */}
          <div className="bg-white rounded-2xl shadow-md border border-gray-100">
            {/* Header discret */}
            <div className="flex items-center justify-between px-5 xl:px-3 2xl:px-5 py-4 xl:py-2.5 2xl:py-4 border-b border-slate-100 rounded-t-2xl bg-gradient-to-r from-blue-50 via-sky-100 to-cyan-50/50">
              <div className="flex items-center gap-2.5">
                <BarChart3 className="w-5 h-5 xl:w-4 xl:h-4 text-blue-600" />
                <div>
                  <h3 className="text-slate-700 text-base xl:text-sm 2xl:text-base font-bold">Résultats Évaluation Nationale</h3>
                  <p className="text-xs xl:text-[11px] text-slate-400 font-medium hidden sm:block">Analyse détaillée par question</p>
                </div>
              </div>
              <ExportEvalNatGroupe resultats={EvalNat} />
            </div>

            {/* Category selector */}
            <div className="px-6 xl:px-4 2xl:px-5 3xl:px-6 py-4 xl:py-3 2xl:py-3.5 3xl:py-4 bg-gray-50 border-b border-gray-100">
              <div className="flex flex-wrap gap-2 xl:gap-1.5 2xl:gap-2 3xl:gap-2">
                {buttons.map(button => (
                  <button
                    key={button.key}
                    className={`px-5 xl:px-3.5 2xl:px-4 3xl:px-5 py-2.5 xl:py-2 2xl:py-2 3xl:py-2.5 rounded-xl text-sm xl:text-xs 2xl:text-xs 3xl:text-sm font-semibold transition-all duration-200 ${
                      testSpecifique === button.key
                        ? 'bg-blue-600 text-white shadow-md shadow-blue-200'
                        : 'bg-white text-gray-600 border border-gray-200 hover:border-blue-300 hover:bg-blue-50'
                    }`}
                    onClick={() => handleTestSpecifiqueClick(button.key)}
                  >
                    {button.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Main content: sidebar + detail */}
            <div className="flex flex-col xl:flex-row">
              {/* Sidebar - Question list */}
              <div className="xl:w-[250px] 2xl:w-[275px] 3xl:w-[300px] flex-shrink-0 xl:border-r border-gray-100">
                <div className="px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-3 xl:py-2 2xl:py-2.5 3xl:py-3 border-b border-gray-100 flex items-center gap-2 xl:gap-1.5 2xl:gap-1.5 3xl:gap-2">
                  <Layers className="w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5 text-blue-600" />
                  <h3 className="font-semibold text-gray-800 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">Questions</h3>
                </div>
                <div className="xl:sticky xl:top-0 xl:max-h-[70vh] xl:overflow-y-auto overflow-x-hidden">
                  {(EvalNat && currentTestSpecifique) &&
                    <TestSpecifique testSpecifique={currentTestSpecifique} EvalNat={EvalNat} handleItemClick={handleItemClick} />
                  }
                </div>
              </div>
              {/* Detail panel */}
              <div className="flex-1 min-w-0">
                <ResultatParItem EvalNat={EvalNat} itemDetail={itemDetail} testSpecifique={currentTestSpecifique}
                  AutomatismeQuestions={AutomatismeQuestions} ProblèmesQuestions={ProblèmesQuestions}
                  LexiqueQuestion={LexiqueQuestion} CompetencesLangagieresQuestion={CompetencesLangagieresQuestion}
                  ComprehensionEcritQuestion={ComprehensionEcritQuestion}
                />
              </div>
            </div>
          </div>
        </div>
    )
}

export default ResultatEvalNat;
